module.exports = __webpack_public_path__ + "static/media/private-room-icon.89b27906.svg";